import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-rt-data-services',
	templateUrl:'./DataServicesPage.html',
	styles: [],
	styleUrls:['./DataServicesPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class DataServicesPage
{
	mdContent_1171 = `\`@NgDataService\` generates a typed Angular service that communicates with the server via the \`EventBusService\`. Define a Java class, annotate it, and implement \`getData()\` — the framework generates the TypeScript service, registers a listener, and handles serialization. The Angular component receives an \`Observable\` of your data type.`;
	mdContent_1172 = `\`\`\`java
@NgDataService(value = "SalesDashboardService",
    listenerName = "salesDashboard")
public class SalesDashboardDataService
        implements INgDataService<SalesDashboardDataService> {

    @Override
    public DynamicData getData(AjaxCall<?> call, AjaxResponse<?> response) {
        var data = new DynamicData();
        data.put("rows", salesService.findAll());
        return data;
    }
}
\`\`\``;
	mdContent_1173 = `Data services can operate over the AJAX pipeline or the WebSocket event bus. When the event bus is available, the generated service listens for push updates automatically. When it is not, data is fetched on component creation.`;
}
